import { Stack, StackProps } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import React from 'react';

interface BreakFlexProps extends StackProps {
  breakpoint: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  children: React.ReactNode;
  sx?: any;
};

function BreakingFlex({ breakpoint, children, ...rest }: BreakFlexProps) {
  const theme = useTheme();
  const themeBreakpoint = useMediaQuery(theme.breakpoints.down(breakpoint));

  return (
    <Stack
      direction={themeBreakpoint ? 'column' : 'row'}
      alignItems={themeBreakpoint ? 'stretch' : 'center'}
      gap={2}
      width={1}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
    >
      {children}
    </Stack>
  );
}

export default BreakingFlex;
